export default "__VITE_ASSET__BHDewebM__"